import { useMemo } from 'react';
import {
  IClientBusinessModel,
  IClientAssociationModel,
} from '../../../../Types/ClientModelTypes';
import { IDetailCompProps } from '../../../../Types/MasterDetailTypes';
import { getAssociations } from '../../../../Model/avenyModelUtils';
import { complement } from 'ramda';
import { objektVyGrupp } from '../../../Delsystem/_Common/Components/BusinessCollectionComponents/ObjektVyGrupp';
import { getDebugFalt } from '../DebugRutinUtils';
import faltVy from '../../../Delsystem/_Common/Components/BusinessCollectionComponents/faltVy';
import associeradObjektListVy from '../../../Delsystem/_Common/Components/BusinessCollectionComponents/associeradObjektListVy';
import objektVySida from '../../../Delsystem/_Common/Components/BusinessCollectionComponents/ObjectVySida';
import { standardVy } from '../../../../Utils/ObjektVyUtils';
import { debugAssociationListVy } from '../DebugAssociationList/debugAssociationListVy';

const zeroOrOneFilter = (asmod: IClientAssociationModel) =>
  asmod.JoinAssociation;

export const DebugViewDetail =
  (collection: IClientBusinessModel) => (props: IDetailCompProps) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const associations = useMemo(
      () => getAssociations(collection).filter(complement(zeroOrOneFilter)),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [collection]
    );
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const attributes = useMemo(
      () =>
        objektVyGrupp(
          'DebugAttribut',
          getDebugFalt(collection.CollectionName).map(x => {
            return faltVy(x);
          }),
          'Attribut'
        ),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [collection.CollectionName]
    );
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const objektLankar = useMemo(
      () =>
        objektVyGrupp(
          'DebugObjekt',
          [associeradObjektListVy(collection.CollectionName)],
          ''
        ),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [collection]
    );
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const associationPages = useMemo(
      () =>
        associations.map((x, index) =>
          objektVySida(
            x.AssociationName,
            debugAssociationListVy(x.AssociationName),
            index + 2,
            x.AssociationName,
            true
          )
        ),
      [associations]
    );
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const firstPage = useMemo(
      () => objektVySida('0-nivå', [[attributes], [objektLankar]], 1, '0-nivå'),
      [attributes, objektLankar]
    );
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const DetailView = useMemo(
      () =>
        standardVy([firstPage, ...associationPages], {
          sidaVidSida: false,
          sideBySideWidths: [5, 7],
        }).def(collection).comp,
      [associationPages, firstPage]
    );

    return <DetailView {...props} />;
  };
